import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupRestrictedActionsOffContentProps } from './msg-group-restricted-actions-off-content';
import { MsgGroupRestrictedActionsOffContent } from './msg-group-restricted-actions-off-content';

export interface MsgGroupRestrictedActionsOffProps
  extends MsgGroupRestrictedActionsOffContentProps {}

export const MsgGroupRestrictedActionsOff = memo(function MsgGroupRestrictedActionsOff({
  message,
}: MsgGroupRestrictedActionsOffProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupRestrictedActionsOffContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
